import { __awaiter, __extends, __generator } from "tslib";
import { AbstractOfflineDataCommitter } from '../../offline-data/offline-data-committer';
import { DocumentStatus } from '@tencent/ark-model';
import { DocumentStatusStorage } from '@tencent/ark-storage';
import { networkRequest } from '@tencent/ark-request';
import { ApiError } from '../../error/api-error';
import { ApiErrorCode } from '../../error/api-error-code';
import { CommonChangeDataComposer } from '../../util/change-data-composer';
import { LoggerProxy } from '../../logger/logger-proxy';
var BaseOfflineDataCommitter = /** @class */ (function (_super) {
    __extends(BaseOfflineDataCommitter, _super);
    function BaseOfflineDataCommitter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(BaseOfflineDataCommitter.prototype, "checkIfOfflineDataCool", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (offlineData, param, storageManager) {
            return __awaiter(this, void 0, void 0, function () {
                var isFailedBefore;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            LoggerProxy.info(BaseOfflineDataCommitter.tag, "\u6821\u9A8C\u79BB\u7EBF\u6570\u636E\u7684\u6709\u6548\u6027, \u79BB\u7EBF\u6570\u636E\u6761\u6570 = ".concat(offlineData.length, ", param = "), param);
                            // 没有未提交数据，直接抛异常
                            if (offlineData.length === 0) {
                                // 按道理不会进来这里，但是旧逻辑也有，不敢随便扔掉
                                throw new ApiError({
                                    code: ApiErrorCode.CheckOfflineDataError,
                                    subCode: -20001,
                                    message: 'BaseOfflineDataCommitter 参数错误。待提交的 OfflineData 数组长度为 0',
                                });
                            }
                            return [4 /*yield*/, this.isCommitFailedBefore(offlineData, param, storageManager)];
                        case 1:
                            isFailedBefore = _a.sent();
                            if (isFailedBefore) {
                                LoggerProxy.error(BaseOfflineDataCommitter.tag, '校验离线数据的有效性出现异常, 原因: 存在提交过且出错的状态');
                                throw new ApiError({
                                    code: ApiErrorCode.CheckOfflineDataError,
                                    subCode: -20002,
                                    message: "".concat(BaseOfflineDataCommitter.tag, " \u6821\u9A8C\u79BB\u7EBF\u6570\u636E\u7684\u6709\u6548\u6027\u51FA\u73B0\u5F02\u5E38, \u539F\u56E0: \u5B58\u5728\u63D0\u4EA4\u8FC7\u4E14\u51FA\u9519\u7684\u72B6\u6001"),
                                });
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(BaseOfflineDataCommitter.prototype, "handleConflictOfflineData", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (offlineData, 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        param) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    // doc excel不作任何处理，slide自己复写
                    return [2 /*return*/, offlineData];
                });
            });
        }
    });
    Object.defineProperty(BaseOfflineDataCommitter.prototype, "composeOfflineData", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (offlineData, newDocumentParam) {
            return CommonChangeDataComposer.compose(offlineData, newDocumentParam);
        }
    });
    Object.defineProperty(BaseOfflineDataCommitter.prototype, "postOfflineData", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (commitRequest, param) {
            return __awaiter(this, void 0, void 0, function () {
                var commitRequestUrl, content;
                return __generator(this, function (_a) {
                    LoggerProxy.info(BaseOfflineDataCommitter.tag, 'CGI 请求提交离线数据, param = ', param);
                    commitRequestUrl = "/dop-api/commitchanges?padId=".concat(param.globalPadId, "&xsrf=").concat(param.config.requestParams.xsrf);
                    content = JSON.stringify(commitRequest);
                    content = encodeURIComponent(content);
                    return [2 /*return*/, networkRequest.post(commitRequestUrl, "data=".concat(content), {
                            contentType: 'application/x-www-form-urlencoded',
                        })];
                });
            });
        }
    });
    Object.defineProperty(BaseOfflineDataCommitter.prototype, "checkIfCommitResponseCool", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (commitResponse, param, storageManager) {
            return __awaiter(this, void 0, void 0, function () {
                var status, response, retCode, retMsg, errorCodes;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            LoggerProxy.info(BaseOfflineDataCommitter.tag, '校验提交离线数据请求的响应数据有效性, param = ', param);
                            status = commitResponse.status;
                            if (status !== 200) {
                                LoggerProxy.error(BaseOfflineDataCommitter.tag, "\u6821\u9A8C\u79BB\u7EBF\u6570\u636E\u8BF7\u6C42\u7684\u54CD\u5E94\u6570\u636E\u5F02\u5E38, \u539F\u56E0: commitResponse \u72B6\u6001\u7801 = ".concat(status));
                                // 提交出错了
                                throw new ApiError({
                                    code: ApiErrorCode.CommitOfflineDataError,
                                    subCode: -40001,
                                    message: "".concat(BaseOfflineDataCommitter.tag, " \u6279\u91CF\u63D0\u4EA4\u79BB\u7EBF\u6570\u636E\u5F02\u5E38\uFF0Cstatus = ").concat(status, "\u3002"),
                                });
                            }
                            response = commitResponse.data;
                            retCode = response.retcode;
                            retMsg = response.retmsg;
                            errorCodes = this.getNotReTryErrorCodes();
                            if (!(errorCodes.indexOf(retCode) >= 0)) return [3 /*break*/, 2];
                            this.handleFatalCommitError(retCode, retMsg, param);
                            // 更新文档的提交错误状态
                            return [4 /*yield*/, this.updateDocumentStatus(param, storageManager)];
                        case 1:
                            // 更新文档的提交错误状态
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            if (retCode !== 0) {
                                LoggerProxy.error(BaseOfflineDataCommitter.tag, "\u63D0\u4EA4\u79BB\u7EBF\u6570\u636E\u8BF7\u6C42\u7684\u54CD\u5E94\u6570\u636E\u5F02\u5E38, \u539F\u56E0: commitResponse retCode = ".concat(retCode));
                                throw new ApiError({
                                    code: ApiErrorCode.CommitOfflineDataError,
                                    subCode: -40002,
                                    message: "".concat(BaseOfflineDataCommitter.tag, " \u6279\u91CF\u63D0\u4EA4\u79BB\u7EBF\u6570\u636E\u65F6\u53D1\u751F\u9519\u8BEF\u3002\u539F\u56E0: commitResponse retCode=").concat(retCode),
                                });
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(BaseOfflineDataCommitter.prototype, "isCommitFailedBefore", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (offlineData, param, storageManager) {
            return __awaiter(this, void 0, void 0, function () {
                var documentStatues, documentStatusCollection, documentStatusStorage, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            LoggerProxy.info(BaseOfflineDataCommitter.tag, '校验是否存在已提交且失败的状态, param = ', param);
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            documentStatusCollection = storageManager.storage.collection(DocumentStatus);
                            documentStatusStorage = new DocumentStatusStorage(documentStatusCollection);
                            return [4 /*yield*/, documentStatusStorage.getStatus(param.config.user.uid, param.secretId)];
                        case 2:
                            documentStatues = _a.sent();
                            return [3 /*break*/, 4];
                        case 3:
                            error_1 = _a.sent();
                            LoggerProxy.error(BaseOfflineDataCommitter.tag, '校验是否存在已提交且失败的状态异常, error = ', error_1);
                            return [2 /*return*/, false];
                        case 4:
                            if ((documentStatues === null || documentStatues === void 0 ? void 0 : documentStatues.lastErrorTimestamp)
                                && !offlineData.some(function (cs) { return cs.createTimestamp > documentStatues.lastErrorTimestamp; })) {
                                // 如果以前有错，且没有新增更新
                                return [2 /*return*/, true];
                            }
                            return [2 /*return*/, false];
                    }
                });
            });
        }
    });
    /**
     * 获取不再重试的错误码集合
     *
     * @return {*}  {number[]}
     */
    Object.defineProperty(BaseOfflineDataCommitter.prototype, "getNotReTryErrorCodes", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return [
                40001, 40003, 40005, 40006, 40022, 40026, 40028, 40034, 40035, 40036, 608674,
                50095, 601909, 40021, 50035, 50039,
                70002,
            ];
        }
    });
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Object.defineProperty(BaseOfflineDataCommitter.prototype, "handleFatalCommitError", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (retCode, retMsg, param) { }
    });
    Object.defineProperty(BaseOfflineDataCommitter, "tag", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'BaseOfflineDataCommitter'
    });
    return BaseOfflineDataCommitter;
}(AbstractOfflineDataCommitter));
export { BaseOfflineDataCommitter };
